import axios from "axios";
import {Message} from "element-ui";
import * as cache from "./cache";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 55000
});

// 请求前拦截，设置Token
service.interceptors.request.use(config => {
  config.data = JSON.stringify(config.data);
  config.headers = {
    "Content-Type": "application/json",
    "Authorization": cache.getToken()
  };
  return config
}, error => {
  Promise.reject(error);
});

// 响应拦截,数据验证
service.interceptors.response.use(response => {
    const reData = response.data;
    //1.1 授权失败
    if (reData.errorCode == 0) {
      return reData;
    }
    //1.2 授权失效
    else if (reData.errorCode == -1) {
      cache.removeAuth();
      Message({
        type: "error",
        duration: 1500,
        message: "授权失效，重新登录(" + reData.errorMessage + ")",
        onClose: () => {
          if (window.parent) {
            window.parent.location.href = '/#/login';
          } else {
            window.location.href = '/#/login';
          }
        }
      });
      // 返回错误
      return Promise.reject("error");
    }
    //1.3 业务错误
    else {
      Message({type: "error", duration: 3 * 1000, message: reData.errorMessage});
      return Promise.reject("error");
    }
  },
  error => {
    if ("Network Error" == error.message) {
      Message({type: "error", duration: 3 * 1000, message: "网络连接异常，请确认网络连接"});
    } else {
      Message({type: "error", duration: 3 * 1000, message: error.message});
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js